import { componentStyle } from '@/styling/util/component-style.ts';
import type { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';

export const paginatorStyle = componentStyle<PaginatorDesignTokens>({
    navButton: {
        selectedBackground: '{button.primary.background}',
        selectedColor: '{button.primary.color}',
        borderRadius: '{border.radius.sm}',
    },
});
